import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowRightOutlined } from '@ant-design/icons';
import PageHero from '../components/PageHero';

const NotFoundPage = () => (
  <>
    <Helmet>
      <title>ページが見つかりません | RYU株式会社</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <PageHero label="404 / NOT FOUND" title="ページが見つかりません。" />
    <section className="not-found section">
      <div className="container">
        <p>お探しのページは移動または削除された可能性があります。</p>
        <Link className="text-link" to="/">
          トップページへ戻る
          <ArrowRightOutlined aria-hidden="true" />
        </Link>
      </div>
    </section>
  </>
);

export default NotFoundPage;
